import { useState, useEffect } from 'react';
import CustomCountdown from './CountDown/CountDown';
import './CountDown/CountDown.css';

export default function Tasks() {
    const [deadline, setDeadline] = useState(getNextMidnight());
    function getNextMidnight() {
        const now = new Date();
        const nextMidnight = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0));
        return nextMidnight.getTime();
    }
    useEffect(() => {
        const interval = setInterval(() => {
            const now = Date.now();
            if (now >= deadline) {
                setDeadline(getNextMidnight());
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [deadline]);
    const handleCountdownFinish = () => {
        console.log('Countdown finished');
        setDeadline(getNextMidnight());
    };
    return (
        <div>
            <div>
                <main>
                    <div className='lg:block hidden'>
                        <div className='flex justify-center '>
                            <div
                                className="w-[89%] pt-1 pb-1 pr-1 text-sm rounded-md text-[#d5c7fd] mr-3"
                                style={{ background: 'linear-gradient(95.1deg, #010116 9.74%, #221FFF 89.67%)' }}
                            >
                                <div className='flex justify-end items-center space-x-2'>
                                    <div>Tasks are updated every day.</div>
                                    <div className="flex items-center space-x-3 pr-2">
                                        <div>Next update:</div>
                                        <div>
                                            <CustomCountdown
                                                deadline={deadline}
                                                onFinish={handleCountdownFinish}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='lg:hidden block'>
                        <div className='w-full flex items-center justify-center'>
                            <div
                                className="w-[89%] pt-1 pb-1 pr-1 text-sm rounded-md text-[#d5c7fd] mr-3"
                                style={{ background: 'linear-gradient(95.1deg, #010116 9.74%, #221FFF 89.67%)' }}
                            >
                                <div className='flex flex-col justify-end items-center space-x-2'>
                                    <div className="whitespace-nowrap">Tasks are updated every day.</div>
                                    <div className="flex items-center space-x-3 pr-2 whitespace-nowrap">
                                        <div>Next update:</div>
                                        <div>
                                            <CustomCountdown
                                                deadline={deadline}
                                                onFinish={handleCountdownFinish}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </main>
            </div>
        </div>
    );
}
